import React from 'react'

import logo from '../assets/Images/MedLogo.png';

const Home = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Estamos en construccion
        </p>
        <p
        >
          Muy pronto Regresaremos!!
        </p>
      </header>
    </div>
  )
}

export default Home